import { useCallback, useMemo, type ReactElement } from 'react';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import type { ProjectContext as ProjectContextType } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';
import { useResource } from '@atlassian/react-resource-router';

type Props = {
	children: (arg1: {
		projectContext: ProjectContextType | null;
		updateProjectContext: (arg1: ProjectContextType) => void;
	}) => ReactElement;
};

const UnifiedProjectContext = ({ children }: Props) => {
	const { data, update: updateResource } = useResource(projectContextResource);

	const updateProjectContext = useCallback(
		({ projectKey: newProjectKey, projectName: newProjectName }: ProjectContextType) => {
			updateResource((oldData) => {
				if (!oldData) {
					return oldData;
				}
				return {
					...oldData,
					projectName: newProjectName,
					projectKey: newProjectKey,
				};
			});
		},
		[updateResource],
	);

	const unifiedProjectContext = useMemo(
		() => ({
			projectContext: data,
			updateProjectContext,
		}),
		[data, updateProjectContext],
	);

	return children(unifiedProjectContext);
};

export default UnifiedProjectContext;
